import React, { useContext, useEffect, useState } from 'react';
import { DarkButton } from 'components/style/Global';
import { IoMdClose } from 'react-icons/io';
import { useTheme } from 'styled-components';
import { Modal } from 'components/NewPortal/Header/AddCampaignModal';
import {
  ModulContainer,
  HeadModul,
  PlatformMidRow,
  BottomRow,
  NavigationButton,
} from 'components/Main/table/TableStyles';
import { fullSources } from 'customHooks/useDataSources';
import { useCampaignContext } from 'context/CampaignContext';
import { platformLogoSelector } from 'methods/platformLogoSelector';
import AuthContext from 'context/AuthContext';
import { prepQuery } from 'methods/prepQuery';
import { useDataQuery } from 'customHooks/useDataQuery';
import InputContext from 'context/InputContext';
import { processDataSource } from 'utils/processDataSource';

interface AddCreativeLibrarySectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dataSource: fullSources, data: any[], outputLocation: string, title?: string | undefined) => void;
  dataSources: fullSources[];
}

const AddCreativeLibrarySectionModal: React.FC<AddCreativeLibrarySectionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  dataSources,
}) => {
  const [selectedDataSource, setSelectedDataSource] = useState<fullSources | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const { dashType, activeCampaign } = useCampaignContext();
  const { user } = useContext(AuthContext);
  const { creativeLibrarySections, setCreativeLibrarySections } = useContext(InputContext);

  const [userMainQuery, setUserMainQuery] = useState<any>(null);
  const [mainData, mainQueryStatus, , mainQueryID, mainOL] = useDataQuery({
    query: userMainQuery,
    querySource: 'QUERY',
  });
  useEffect(() => {
    if (mainData) {
      setIsLoading(false);
      onConfirm(selectedDataSource as fullSources, mainData as any[], mainOL, 'title');
      setSelectedDataSource(null);
    }
  }, [mainData]);

  const handleFetch = async () => {
    if (!selectedDataSource) return;

    // Check if data for this dataSource already exists in creativeLibrarySections
    const existingSection = creativeLibrarySections?.find(
      (section) => section?.dataSourceName === selectedDataSource.name,
    );

    if (existingSection) {
      // Copy existing data without fetching
      onConfirm(
        selectedDataSource as fullSources,
        existingSection.data as any[],
        existingSection.outputLocation || '',
        existingSection.title || 'title',
      );
      setSelectedDataSource(null);
      return;
    }

    setIsLoading(true);

    const processedDataSource = processDataSource(selectedDataSource);
    const q = prepQuery(processedDataSource, true, activeCampaign, user);

    setUserMainQuery(q);

    // Simulate loading
    // setTimeout(() => {
    //   setIsLoading(false);
    //   onConfirm(selectedDataSource);
    //   setSelectedDataSource(null);
    // }, 2000);
  };

  if (!isOpen) return null;

  return (
    <Modal>
      <HeadModul>
        <button type="button" className="x" onClick={onClose}>
          <IoMdClose className="closeIcon" />
        </button>
        <ModulContainer>
          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div>Loading...</div>
            </div>
          ) : (
            <>
              {/* Data Sources Grid */}
              <PlatformMidRow isGraph={false}>
                <h1>Data Source</h1>
                <br />
                <h2>Choose a data source for your query </h2>
                <div className="platformsArray">
                  {dataSources
                    .filter((el) =>
                      dashType === 'DIGITAL' || dashType === 'INSOURCE_DATA' || dashType === 'TV'
                        ? el.name !== 'TV' &&
                          el.name !== 'RADIO' &&
                          el.name !== 'CINEMA' &&
                          el.name !== 'OOH' &&
                          el.name !== 'PRINT' &&
                          el.name !== 'SEARCH' &&
                          el.name !== 'Custom'
                        : // : dashType === 'SEARCH'
                          //   ? el.name === 'Paid Search'
                          el.name === dashType,
                    )
                    .map((platform: any) => (
                      <label key={platform.name}>
                        <input
                          // ref={platformButton}
                          type="radio"
                          name="platforms"
                          value={platform.name}
                          onChange={(event) => setSelectedDataSource(platform)}
                          // onChange={(event) => handlePlatformChange(event.target.value)}
                          id={platform.name}
                        />
                        <div className="checked">
                          <span style={{ fontSize: '1.5rem', marginBottom: '-5px' }}>
                            {platformLogoSelector(platform.name)}
                          </span>
                          <span>{platform.name}</span>
                        </div>
                      </label>
                    ))}
                </div>
              </PlatformMidRow>

              {/* Actions */}
              <BottomRow>
                <NavigationButton type="button" style={{ backgroundColor: 'transparent' }} onClick={onClose}>
                  Cancel
                </NavigationButton>
                <DarkButton onClick={handleFetch} disabled={!selectedDataSource}>
                  Fetch
                </DarkButton>
              </BottomRow>
            </>
          )}
        </ModulContainer>
      </HeadModul>
    </Modal>
  );
};

export default AddCreativeLibrarySectionModal;
